<template>
  <v-navigation-drawer

    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :src="barImage"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    class="elevation-3"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
<!--     mobile-break-point="960"-->
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <!-- <v-divider class="mb-1" /> -->

<!--    <v-app-bar dark color="rgb(233 233 233)">-->
<!--      &lt;!&ndash; <v-img-->
<!--        src="/img/porsan1.png"-->
<!--        width="50"-->
<!--      /> &ndash;&gt;-->
<!--      <img src="/img/logo.png" width="50px" alt="" />-->
<!--      <h5 class="siteTitle mr-2">مدیریت مردم نما</h5>-->
<!--    </v-app-bar>-->
    <!-- <v-divider class="mb-2" /> -->

    <v-list expand nav class="mt-15">
      <!-- Style cascading bug  -->

      <template v-for="(item, i) in computedItems">
        <base-item
          v-if="(canShowLink(item.level) && !item.children)"
          :key="`item-${i}`"
          :item="item"
        />

        <base-item-group v-if="(canShowLink(item.level) && item.children)" :key="`group-${i}`" :item="item">
        </base-item-group>
      </template>

      <!-- Style cascading bug  -->
      <div />
    </v-list>

    <!--    <template v-slot:append>-->
    <!--      <base-item-->
    <!--        :item="{-->
    <!--          title: $t('upgrade'),-->
    <!--          icon: 'mdi-package-up',-->
    <!--          to: '/upgrade',-->
    <!--        }"-->
    <!--      />-->
    <!--    </template>-->
    <div>
      <!-- <hr color="white" /> -->
    </div>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    items: [
      {
        title: "داشبورد",
        icon: "mdi-home",
        to: "/",
        roles: [],
        level: [],
      },
      {
        title: "1400",
        icon: "mdi-text-box-multiple",
        to: "/contracts-list-1400",
        roles: [],
        level: [],
      },
      {
        title: "1401",
        icon: "mdi-text-box-multiple",
        to: "/contracts-list-1401",
        roles: [],
        level: [],
      },
      {
        title: "1402",
        icon: "mdi-text-box-multiple",
        to: "/contracts-list-1402",
        roles: [],
        level: [],
      },
      // {
      //   title: "1401",
      //   icon: "mdi-text-box-multiple",
      //   to: "/contracts-list-01",
      //   roles: [],
      //   level: [],
      // },
      // {
      //   title: "1400",
      //   icon: "mdi-text-box-multiple",
      //   to: "/contracts-list",
      //   roles: [],
      //   level: [],
      // },
      // {
      //   title: "1399",
      //   icon: "mdi-text-box-multiple",
      //   to: "/factors-list-99",
      //   roles: [],
      //   level: [],
      // },
      // {
      //   title: "1398",
      //   icon: "mdi-text-box-multiple",
      //   to: "/factors-list-98",
      //   roles: [],
      //   level: [],
      // },
      // // {
      // //   title: " مدیریت کاربران ",
      // //   icon: "mdi-text-box-multiple",
      // //   group: "",
      // //   roles: [],
      // //   level: [],
      // //   children: [
      // //     {
      // //       title: "جستجوی کاربر",
      // //       icon: "mdi-account-search",
      // //       to: "search-user",
      // //       roles: [],
      // //       level: [],
      // //     },
      // //   ],
      // // },
      //

    ],
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
      };
    },
    currentUser() {
      return this.$store.getters["userInfo/getUserInfo"];
      //return this.$store.getters.getCurrentUser
    },
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        //title: this.$t(item.title),
        title: item.title,
      };
    },
    canShowLink(level) {
      if (level.length === 0) return true;
      if (this.currentUser.level === level[0]) {
        return true;
      } else {
        false;
      }
      // return (
      //   roles.some(role => this.currentUser.organizationRoles.includes(role)) &&
      //   organizationTypes.indexOf(this.currentUser.organizationType) > -1
      // )
    },
  },
  components: {},
};
</script>
<style >


</style>
<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px


</style>

<style >
/*.theme--dark.v-navigation-drawer {*/
/*  background-color: rgba(154, 154, 154,1);*/
/*}*/
/*.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),.v-list-item__icon {*/
/*  color:#78909c !important;*/

/*}*/
/*.v-list-item__icon i{*/
/*  color:#78909c !important;*/
/*}*/
/*.v-list-item--active .v-list-item__title{*/
/*  font-family: IranSansBold !important;*/
/*}*/
/*.v-list-item--active .v-list-item__icon i{*/
/*  color: #16293f  !important;*/
/*}*/
/*.my-active{*/
/*  font-family: IranSansBold !important;*/
/*  font-weight: bold !important;*/
/*  color: #16293f  !important;*/
/*  !*color: #00c853 !important;*!*/
/*  !*font-family: IRANSansWeb-FaNum-Bold !important;*!*/
/*}*/
/*.v-list-item__icon i{*/
/*  font-size: 19px !important;*/
/*}*/
/*.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle{*/
/*  !*font-size: 16px !important;*!*/
/*}*/
/*.v-list-item--link:before{*/
/* background-color: inherit;*/
/*}*/
/*.v-list-item--link:hover{*/
/*  color: #00b0ff;*/
/*}*/
/*v-list-group__header:hover{*/
/*  color: #00b0ff !important;*/
/*}*/
</style>
<style>
/*.theme--dark.v-navigation-drawer {*/
/*  background-color: #16293f;*/
/*}*/
/*.v-navigation-drawer .v-icon.v-icon {*/
/*  font-size: 16px;*/

/*}*/
/*.theme--dark.v-list-item:hover::before {*/
/*  opacity: 0;*/
/*}*/
/*!*.v-list-item:hover > .v-list-item__icon{*!*/
/*!*  color: #00b0ff !important;*!*/
/*!*}*!*/
/*.v-list-item{*/
/*  color:#78909c !important;*/
/*}*/
/*.v-list-item:hover{*/
/*  color: #bde1ff !important;*/
/*}*/
/*.v-list--nav .v-list-item:before{*/
/*  background: none;*/
/*}*/
/*!*.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {*!*/
/*!*  color: #78909c !important;*!*/

/*!*}*!*/

/*.theme--dark.v-icon{*/
/*  color: #78909c ;*/
/*}*/
/*.v-list-group__items{*/
/*  !*padding-right: 8px;*!*/
/*}*/
/*.v-list-group__items .v-list-item--active{*/
/*  color: #44b404 !important;*/
/*  font-weight: bold !important;*/
/*}*/

/*.v-list-item--active:not(:first-child){*/
/*  color: #d905b0 !important;*/
/*}*/
/*.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled)*/
/*.v-application .v-navigation-drawer .v-navigation-drawer__content .v-list .v-list-group .v-list-group__header .v-list-item__content .v-list-item__title{*/
/*  color: #757575;*/
/*}*/
/*.v-list-group--active > .v-list-group__header .v-list-item, .v-list-group--active > .v-list-group__header .v-list-item__content, .v-list-group--active > .v-list-group__header .v-list-group__header__prepend-icon .v-icon{*/
/*  color: #757575;*/
/*}*/
/*.v-list .v-list-item--active .v-icon, .v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle{*/
/*  color: #757575;*/
/*}*/
/*.v-list .v-list-item--active .v-icon,.v-list-item .v-list-item__title {*/
/*  color: white;*/
/*}*/
/*.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){*/
/*  color: white;*/
/*}*/
</style>
